(function () {
  function prefersReduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function cleanup(el) {
    let api = el && el.__vxRing;
    if (!api) return;
    api.destroy();
    el.__vxRing = null;
    delete el.dataset.vxInit;
  }

  function init(el) {
    if (!el || el.dataset.vxInit === '1') return;
    cleanup(el);
    el.dataset.vxInit = '1';

    let stage = el.querySelector('[data-vx-ring-stage]');
    let track = el.querySelector('[data-vx-ring-track]');
    let cards = Array.prototype.slice.call(el.querySelectorAll('[data-vx-ring-card]'));
    let n = cards.length;
    if (!stage || !track || !n) return;

    let speed = parseFloat(el.dataset.speed) || 0;
    /* left = travel right→left; right = travel left→right */
    let dir = el.dataset.dir === 'right' ? -1 : 1;
    let gap = parseFloat(el.dataset.gap);
    if (isNaN(gap)) gap = 20;

    /* India ring starts at 180deg so image 6 is front, same as Vetra_sec_7. */
    let angle = 180;
    let radius = 0;
    let step = 360 / n;
    let raf = 0;
    let lastTs = 0;
    let inView = true;
    let hovering = false;
    let dragging = false;
    let dragMoved = false;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startAngle = 0;
    let lastX = 0;
    let lastT = 0;
    let velocity = 0;
    let inertia = false;
    let touchAxis = null;
    let reduced = prefersReduced();
    let frontIndex = -1;
    let DRAG_CLICK_PX = 5;
    let DEG_PER_PX = 0.18;
    let TWO_PI = Math.PI * 2;

    function layout() {
      let stageW = stage.clientWidth || window.innerWidth || 1200;
      let stageH = stage.clientHeight || 400;
      let baseW = parseFloat(getComputedStyle(el).getPropertyValue('--vxr-card-w')) || 200;

      /* Slightly wider than the original 0.4, still well under a full diameter. */
      let fillR = stageW * 0.46;
      let packR = ((baseW + gap) * n) / TWO_PI;
      radius = Math.max(packR, fillR);

      /* Widen cards to pack on this radius using the gap setting */
      let slot = (TWO_PI * radius) / n;
      let maxW = Math.min(stageH * 0.9 * (2 / 3), stageW * 0.25);
      let cardW = Math.min(slot - gap, maxW);
      if (cardW < baseW) cardW = baseW;

      /* Keep a little of the extra radius (original was 0.45). */
      if (cardW + gap < slot) {
        let tightR = ((cardW + gap) * n) / TWO_PI;
        radius = tightR + (radius - tightR) * 0.55;
      }

      for (let i = 0; i < n; i++) {
        cards[i].style.width = cardW + 'px';
        /* Negative yaw matches India: the next image sits to the right. */
        cards[i].style.transform =
          'translate(-50%, -50%) rotateY(' + (-i * step) + 'deg) translateZ(' + -radius + 'px)';
      }
      paint();
    }

    function paint() {
      track.style.transform = 'rotateY(' + angle + 'deg)';

      /* Centre of the concave arc (far wall) is at world yaw ≈ 0 */
      let best = 0;
      let bestDelta = 181;
      for (let i = 0; i < n; i++) {
        let world = ((angle - i * step) % 360 + 360) % 360;
        let delta = Math.min(world, 360 - world);
        if (delta < bestDelta) {
          bestDelta = delta;
          best = i;
        }
      }
      if (best !== frontIndex) {
        if (frontIndex >= 0) cards[frontIndex].classList.remove('is-front');
        cards[best].classList.add('is-front');
        frontIndex = best;
      }
    }

    function targetSpeed() {
      if (reduced || hovering || !inView || dragging || speed <= 0) return 0;
      return dir * speed;
    }

    function tick(ts) {
      if (!lastTs) lastTs = ts;
      let dt = Math.min(0.05, (ts - lastTs) / 1000);
      lastTs = ts;
      let autoSpd = targetSpeed();

      if (dragging) {
        /* angle driven by pointer */
      } else if (inertia) {
        angle += velocity * dt * 1000;
        if (autoSpd !== 0) {
          velocity += (autoSpd / 60 - velocity) * Math.min(1, dt * 3);
          if (Math.abs(velocity - autoSpd / 60) < 0.01) {
            velocity = 0;
            inertia = false;
          }
        } else {
          velocity *= Math.pow(0.92, dt * 60);
          if (Math.abs(velocity) < 0.02) {
            velocity = 0;
            inertia = false;
          }
        }
      } else if (autoSpd !== 0) {
        angle += autoSpd * dt;
      }

      paint();

      if (!dragging && !inertia && autoSpd === 0) {
        raf = 0;
        lastTs = 0;
        return;
      }
      raf = requestAnimationFrame(tick);
    }

    function startLoop() {
      if (raf) return;
      lastTs = 0;
      raf = requestAnimationFrame(tick);
    }

    function stopLoop() {
      if (!raf) return;
      cancelAnimationFrame(raf);
      raf = 0;
      lastTs = 0;
    }

    function ensureLoop() {
      if (inView || dragging || inertia) startLoop();
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      dragMoved = false;
      inertia = false;
      velocity = 0;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      lastX = e.clientX;
      lastT = performance.now();
      startAngle = angle;
      touchAxis = null;
      stage.classList.add('is-dragging');
      ensureLoop();
      try {
        stage.setPointerCapture(pointerId);
      } catch (err) {}
    }

    function onPointerMove(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      let dx = e.clientX - startX;
      let dy = e.clientY - startY;

      if (e.pointerType === 'touch') {
        if (!touchAxis) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          touchAxis = Math.abs(dx) > Math.abs(dy) * 1.15 ? 'h' : 'v';
        }
        if (touchAxis === 'v') return;
        if (e.cancelable) e.preventDefault();
      }

      if (Math.abs(dx) > DRAG_CLICK_PX || Math.abs(dy) > DRAG_CLICK_PX) dragMoved = true;

      let now = performance.now();
      let frameDx = e.clientX - lastX;
      let frameDt = Math.max(1, now - lastT);
      /* Invert so drag left moves content right→left (matches auto-rotate) */
      velocity = (-frameDx * DEG_PER_PX) / frameDt;
      lastX = e.clientX;
      lastT = now;

      angle = startAngle - dx * DEG_PER_PX;
      paint();
    }

    function onPointerUp(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      dragging = false;
      pointerId = null;
      stage.classList.remove('is-dragging');
      touchAxis = null;
      if (Math.abs(velocity) > 0.002) {
        inertia = true;
      }
      ensureLoop();
    }

    function onClick(e) {
      if (!dragMoved) return;
      e.preventDefault();
      e.stopPropagation();
    }

    function onEnter() {
      hovering = true;
    }

    function onLeave() {
      hovering = false;
      ensureLoop();
    }

    function onResize() {
      layout();
    }

    let io = new IntersectionObserver(
      function (entries) {
        inView = entries[0] && entries[0].isIntersecting;
        if (inView) startLoop();
        else if (!dragging && !inertia) stopLoop();
      },
      { root: null, rootMargin: '100px 0px', threshold: 0.01 }
    );
    io.observe(el);

    let ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(onResize) : null;
    if (ro) ro.observe(stage);
    else window.addEventListener('resize', onResize, { passive: true });

    stage.addEventListener('pointerdown', onPointerDown);
    stage.addEventListener('pointermove', onPointerMove, { passive: false });
    stage.addEventListener('pointerup', onPointerUp);
    stage.addEventListener('pointercancel', onPointerUp);
    stage.addEventListener('click', onClick, true);
    stage.addEventListener('mouseenter', onEnter);
    stage.addEventListener('mouseleave', onLeave);

    layout();
    startLoop();

    el.__vxRing = {
      rotateToIndex: function (index) {
        if (index < 0 || index >= n) return;
        angle = -index * step;
        inertia = false;
        velocity = 0;
        paint();
      },
      destroy: function () {
        stopLoop();
        io.disconnect();
        if (ro) ro.disconnect();
        else window.removeEventListener('resize', onResize);
        stage.removeEventListener('pointerdown', onPointerDown);
        stage.removeEventListener('pointermove', onPointerMove);
        stage.removeEventListener('pointerup', onPointerUp);
        stage.removeEventListener('pointercancel', onPointerUp);
        stage.removeEventListener('click', onClick, true);
        stage.removeEventListener('mouseenter', onEnter);
        stage.removeEventListener('mouseleave', onLeave);
        stage.classList.remove('is-dragging');
        if (frontIndex >= 0) cards[frontIndex].classList.remove('is-front');
      }
    };
  }

  function boot(scope) {
    let roots = (scope || document).querySelectorAll('[data-vx-ring]');
    let i;
    for (i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (!window.__vxRingBound) {
    window.__vxRingBound = true;

    document.addEventListener('shopify:section:load', function (e) {
      let node = e.target.querySelector
        ? e.target.querySelector('[data-vx-ring]')
        : null;
      if (!node && e.target.matches && e.target.matches('[data-vx-ring]')) node = e.target;
      if (!node) return;
      delete node.dataset.vxInit;
      init(node);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      let node = e.target.querySelector
        ? e.target.querySelector('[data-vx-ring]')
        : null;
      if (!node && e.target.matches && e.target.matches('[data-vx-ring]')) node = e.target;
      if (node) cleanup(node);
    });

    document.addEventListener('shopify:block:select', function (e) {
      let card = e.target.closest ? e.target.closest('[data-vx-ring-card]') : null;
      if (!card && e.target.hasAttribute && e.target.hasAttribute('data-vx-ring-card')) {
        card = e.target;
      }
      if (!card) return;
      let sectionRoot = card.closest('[data-vx-ring]');
      if (!sectionRoot) return;
      if (sectionRoot.dataset.vxInit !== '1') init(sectionRoot);
      let api = sectionRoot.__vxRing;
      if (!api) return;
      let idx = parseInt(card.getAttribute('data-index'), 10);
      if (!isNaN(idx)) api.rotateToIndex(idx);
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      let card = e.target.closest ? e.target.closest('[data-vx-ring-card]') : null;
      if (!card && e.target.hasAttribute && e.target.hasAttribute('data-vx-ring-card')) {
        card = e.target;
      }
      let sectionRoot = card
        ? card.closest('[data-vx-ring]')
        : e.target.querySelector && e.target.querySelector('[data-vx-ring]');
      if (!sectionRoot) return;
      delete sectionRoot.dataset.vxInit;
      init(sectionRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }
})();
